import { createFileRoute } from "@tanstack/react-router";
import Materiais from "@/pages/app/Materiais";

export const Route = createFileRoute("/app/materiais")({
  head: () => ({ meta: [{ title: "Materiais | Braussie - Nutri" }] }),
  component: Materiais,
});
